import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Shared";

const BOARDROOM_IMG =
  "https://images.pexels.com/photos/7433844/pexels-photo-7433844.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function ImageBreak() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      data-testid="doctrine-section"
      className="relative flex h-[440px] items-center justify-center overflow-hidden md:h-[520px]"
    >
      <motion.img
        src={BOARDROOM_IMG}
        alt="Boardroom strategy session"
        style={{ y }}
        className="absolute inset-x-0 top-[-12%] h-[124%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-[#070E1B]/82" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(7,14,27,0.72),rgba(7,14,27,0.25)_70%)]" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#070E1B] via-transparent to-[#070E1B]" />

      <div className="relative z-10 mx-auto max-w-4xl px-5 text-center sm:px-8">
        <Reveal>
          <p className="font-mono-alt text-[10px] uppercase tracking-[0.34em] text-[#D4AF37]">
            The BYOT Doctrine
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <blockquote
            data-testid="doctrine-quote"
            className="mt-6 font-serif text-3xl italic leading-snug text-[#F7F5F0] sm:text-4xl lg:text-5xl"
          >
            "Policy is <span className="gold-text not-italic">architecture.</span> Markets are{" "}
            <span className="gold-text not-italic">momentum.</span> We build for both."
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
}
